import React from 'react';
import { IconButton } from '@icecreamsocial/components';
import { SmsIcon } from '../SupportedIcons';
import { isMobileOrTablet } from '../../../utils';
import { useIntl } from 'react-intl';

export const SmsButton = ({ ...rest }) => {
	const intl = useIntl();

	/**
	 * localization
	 */
	const SMS = intl.formatMessage({
		id: 'button.sms',
		defaultMessage: 'SMS',
		description: 'Call to action text for users to share using SMS services',
	});

	return (
		isMobileOrTablet() && (
			<IconButton backgroundColor='accent' textColor='bodyInverse' {...rest}>
				<IconButton.Icon as={SmsIcon} />
				<IconButton.Text typoSize='1.1em'>{SMS}</IconButton.Text>
			</IconButton>
		)
	);
};
